import React from "react";
import { FormattedMessage } from "react-intl";
import { ScheduleTime } from "../scheduleTime/ScheduleTime";
import { ScheduleDays } from "../scheduleDays/ScheduleDays";
import { getDaysShifted } from "../schedules.selectors";
import _ from "lodash";
import { Mobile, NotMobile } from "../../../../../hocs/Responsive";
import { useSelector } from "react-redux";
import { getFirstDayOfWeek } from "../../../../../store/config.selectors";
import { is24HourFormat } from "../../../../../store/account";

export const ScheduleEditForm = ({
  schedule,
  onDaysChange,
  onTimePickerChange,
}) => {
  const firstDayOfWeek = useSelector(getFirstDayOfWeek);
  const timeFormat24h = useSelector(is24HourFormat);

  const daysInWeek = getDaysShifted(firstDayOfWeek);

  const sortDaysAndChange = (checked, name) => {
    let days = schedule.selectedDays;

    if (checked) {
      days = _.concat(days, name);
    } else {
      days = _.without(days, name);
    }

    const selectedSortedDays = daysInWeek.filter((day) => days.includes(day));

    onDaysChange(selectedSortedDays);
  };

  const daysProps = {
    days: daysInWeek,
    selectedDays: schedule.selectedDays,
    onDaysChange: ({ target }) => {
      const { checked, name } = target;

      sortDaysAndChange(checked, name);
    },
  };
  const timeProps = {
    timeFormat24h,
    timeStart: schedule.timeStart,
    timeEnd: schedule.timeEnd,
    onTimePickerChange,
  };

  return (
    <div className={"schedule__edit-form"}>
      <NotMobile>
        <ScheduleDays {...daysProps} />
        <ScheduleTime {...timeProps} />
      </NotMobile>
      <Mobile>
        <ScheduleTime {...timeProps} />
        <div className={"text-label sr-only"}>
          <FormattedMessage id={"schedule_days_on"} />
        </div>
        <ScheduleDays {...daysProps} showFullNames />
      </Mobile>
    </div>
  );
};
